import { parse } from 'iso8601-duration';

export default (ISODuration) => {
  const allTimeUnits = parse(ISODuration);
  const arrayOfAllTimeUnits = Object.entries(allTimeUnits);

  return arrayOfAllTimeUnits.find((timeUnit) => timeUnit[1] > 0);
};
